import { createFileRoute } from '@tanstack/react-router';
import { ViewQuotePage } from '@/features/client/quotes/view-quote';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/quotes/$id/')({
  beforeLoad: clientGuard,
  component: ViewQuoteRoute,
});

function ViewQuoteRoute() {
  const { id } = Route.useParams();
  return <ViewQuotePage quoteId={id} />;
}
